import React from 'react';

import Block from '../components/block';
import Title from '../components/my-title';

import BlockCover from '../components/block-cover';
import ContactImage from '../assets/contact.jpg'

const MentionsLegales = () => (
  <div>
    <Block className="block-grey-background">
      <Title>Mentions légales</Title>
      <div className="row justify-content-center">
        <div className="col-12 col-md-9 ">
          <p className="light fs-16 lh-23 mb-4">
            <strong className="color-red">CNIL : Déclarations légales et obligatoires</strong><br />
            Conformément à la loi en vigueur au 1er juin 2000, ce site Internet a fait l’objet d’une déclaration auprès de la CNIL. Conformément à la loi française N·78-17 du 6 janvier 1978 relative à l’informatique, aux fichiers et aux libertés, vous disposez d’un droit d’accès, de modification de rectification et de suppression de données qui vous concernent. Pour exercer ce droit, écrivez nous.<br />
            <br />
            <strong className="color-red">Identification de l’éditeur :</strong> S.A.R.L. Bré<br />
            <br />
            <strong className="color-red">Responsable de la publication :</strong> S.A.R.L. Bré<br />
            <br />
            <strong className="color-red">Responsable de la rédaction :</strong> S.A.R.L. Bré<br />
            Personne chargée du droit à l'accès et à la rectification, de l'information, conformément à la loi 78-17 du 06.01.1978<br />
            e-mail : <a href="mailto:contact@menuiseriebre.fr">contact@menuiseriebre.fr</a><br />
            <br />
            <strong className="color-red">Fournisseur d'hébergement</strong><br />
            <strong>Nom :</strong> Netlify <br />
            <strong>Dénomination ou raison sociale :</strong> Netlify<br />
            <br />
            <strong className="color-red">Conception et réalisation graphique du site</strong><br />
            cowagency - <a href="http://www.cowagency.com" target="_blank">www.cowagency.com</a><br />
            4, avenue Laurent Cely, Tour d'asnières, Hall C - 92600 Asnières-sur-Seine - 09 52 25 62 59<br />
            <br />
            <strong className="color-red">Compatibilité</strong><br />
            - Tout navigateur Niveau 4 minimum - Ecran 1024x768 - Millions couleurs.<br />
            - Pour un meilleur confort de lecture, vous devez disposer des modules libres suivant. <br />
            <br />
            <strong className="color-red">Contenu du site : mise en garde </strong><br />
            www.menuiseriebre.fr est un site d’informations. La S.A.R.L. Bré ne saurait garantir l’exactitude, la complétude, l’actualité et la mise à jour des informations diffusées sur son site Web. Le visiteur reconnaît que l’utilisation de ces informations sont sous sa responsabilité exclusive.<br />
            <br />
            <strong className="color-red">Droits d'auteur et de reproduction</strong><br />
            Ce site est soumis à la législation française et internationale sur les droits d'auteur. Tous les droits de reproduction, sur quelque support que ce soit, sont réservés. La reproduction et l'utilisation du contenu de tout ou partie de ce site autres qu'individuelles et privées sont interdites, sauf autorisation expresse et préalable de l'éditeur.<br />
            <br />
            <strong className="color-red">Droits de propriété </strong><br />
            Article L. 122-4 du code de la propriété intellectuelle : Toute représentation ou reproduction intégrale ou partielle faite sans le consentement de l’auteur ou de ses ayants droit ou ayants cause est illicite. Il en est de même pour la traduction, l’adaptation ou la transformation, l’arrangement ou la reproduction par un art ou un procédé quelconque.<br />
            <br />
            Si vous souhaitez reproduire des documents contenus dans notre site, uniquement à des fins non lucratives, vous devez avant toute diffusion obtenir notre autorisation écrite préalable. Pour cela, vous devez nous adresser une demande écrite par e-mail <a href="mailto:contact@menuiseriebre.fr">contact@menuiseriebre.fr</a> en précisant le contenu exact de ce que vous souhaitez reproduire. Après accord, il vous sera demandé de citer précisément les sources.
          </p>
        </div>
      </div>
    </Block>
  </div>
)

export default MentionsLegales



// WEBPACK FOOTER //
// ./src/pages/mentions-legales.js